import React from "react";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink,
  concat,
} from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";

const uploadLink = createUploadLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`,
  credentials: "include",
});

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
    },
  }));

  return forward(operation);
});

export const client = new ApolloClient({
  link: concat(authMiddleware, uploadLink),
  cache: new InMemoryCache({ addTypename: false }),
});

type PropsType = {
  children: React.ReactNode;
};

export const ApolloManager = (props: PropsType) => {
  return <ApolloProvider client={client}>{props.children}</ApolloProvider>;
};
